import { get } from '@/api/v2';

export const fetchUserMePermits = () => get<Permit[]>('user/me/permit');
